var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNossosCertificados(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 51.358,
    height: 63.141,
    viewBox: "0 0 51.358 63.141",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1426",
    "data-name": "Ret\\xE2ngulo 1426",
    width: 51.359,
    height: 63.141,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2090",
    "data-name": "Grupo 2090",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2089",
    "data-name": "Grupo 2089",
    transform: "translate(0 -0.001)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1319",
    "data-name": "Caminho 1319",
    d: "M1175.365,1455.35a4.308,4.308,0,0,1-1.864-.635,2.16,2.16,0,0,0-2.824,0,3.2,3.2,0,0,1-2.392.553c-.842-.272-1.274-1.137-1.655-1.9a3.585,3.585,0,0,0-.785-1.2,3.65,3.65,0,0,0-1.407-.382,3.288,3.288,0,0,1-2.305-.974,3.242,3.242,0,0,1-.217-2.471,3.642,3.642,0,0,0,.068-1.468,3.55,3.55,0,0,0-.888-1.092,2.469,2.469,0,0,1,0-4.364,3.542,3.542,0,0,0,.887-1.091,3.652,3.652,0,0,0-.067-1.469,3.248,3.248,0,0,1,.217-2.469,3.288,3.288,0,0,1,2.305-.974,3.651,3.651,0,0,0,1.407-.383,3.6,3.6,0,0,0,.786-1.2c.381-.762.814-1.627,1.654-1.9a3.2,3.2,0,0,1,2.392.553,2.16,2.16,0,0,0,2.824,0,3.2,3.2,0,0,1,2.392-.553c.842.272,1.274,1.137,1.655,1.9a3.582,3.582,0,0,0,.785,1.2,3.651,3.651,0,0,0,1.407.383,3.288,3.288,0,0,1,2.305.974,3.242,3.242,0,0,1,.217,2.471,3.644,3.644,0,0,0-.068,1.468,3.55,3.55,0,0,0,.888,1.092,2.469,2.469,0,0,1,0,4.364,3.545,3.545,0,0,0-.887,1.091,3.655,3.655,0,0,0,.067,1.469,3.248,3.248,0,0,1-.217,2.469,3.288,3.288,0,0,1-2.305.974,3.649,3.649,0,0,0-1.407.382,3.6,3.6,0,0,0-.786,1.2c-.381.763-.814,1.627-1.655,1.9a1.7,1.7,0,0,1-.528.082m-3.276-2.314a4.428,4.428,0,0,1,1.94.654c.568.293,1.156.6,1.509.481.381-.123.685-.731.979-1.318a4.281,4.281,0,0,1,1.14-1.619,4.338,4.338,0,0,1,1.913-.589c.646-.1,1.315-.2,1.545-.513s.116-.966.011-1.6a4.348,4.348,0,0,1-.026-2.014,4.21,4.21,0,0,1,1.178-1.559c.475-.464.967-.944.967-1.358s-.491-.892-.966-1.356a4.217,4.217,0,0,1-1.178-1.559,4.34,4.34,0,0,1,.026-2.013c.105-.637.214-1.3-.011-1.6s-.9-.417-1.546-.514a4.337,4.337,0,0,1-1.912-.589,4.262,4.262,0,0,1-1.14-1.618c-.293-.587-.6-1.2-.979-1.318-.353-.115-.941.188-1.509.481a3.206,3.206,0,0,1-3.88,0c-.568-.293-1.156-.6-1.509-.481-.381.123-.685.731-.979,1.318a4.282,4.282,0,0,1-1.14,1.619,4.338,4.338,0,0,1-1.913.589c-.646.1-1.315.2-1.545.513s-.116.966-.011,1.6a4.346,4.346,0,0,1,.026,2.014,4.209,4.209,0,0,1-1.178,1.558c-.475.464-.967.944-.967,1.358s.491.892.966,1.356a4.217,4.217,0,0,1,1.178,1.559,4.343,4.343,0,0,1-.026,2.013c-.105.637-.214,1.3.011,1.6s.9.417,1.546.514a4.338,4.338,0,0,1,1.912.589,4.264,4.264,0,0,1,1.14,1.618c.293.588.6,1.2.979,1.318.353.115.941-.188,1.509-.481a4.428,4.428,0,0,1,1.94-.654",
    transform: "translate(-1133.038 -1398.833)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1320",
    "data-name": "Caminho 1320",
    d: "M1409.168,1664.678a6.7,6.7,0,1,1,4.745-1.959,6.679,6.679,0,0,1-4.745,1.959m0-12.226a5.548,5.548,0,1,0,3.931,1.622,5.534,5.534,0,0,0-3.931-1.622",
    transform: "translate(-1370.117 -1613.221)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1321",
    "data-name": "Caminho 1321",
    d: "M1236.661,2259a.576.576,0,0,1-.463-.233l-1.81-2.44a.82.82,0,0,0-.9-.3l-2.917.874a.577.577,0,0,1-.712-.735l2.7-8.087a.577.577,0,1,1,1.094.365l-2.349,7.033,1.852-.555a1.974,1.974,0,0,1,2.154.714l1.15,1.55,2.1-6.276a.577.577,0,1,1,1.094.365l-2.446,7.326a.577.577,0,0,1-.456.387.57.57,0,0,1-.091.007",
    transform: "translate(-1201.475 -2195.863)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1322",
    "data-name": "Caminho 1322",
    d: "M1732.953,2259a.578.578,0,0,1-.547-.394l-2.446-7.326a.577.577,0,0,1,1.094-.365l2.1,6.276,1.15-1.551a1.976,1.976,0,0,1,2.155-.713l1.85.555-2.349-7.033a.576.576,0,1,1,1.094-.365l2.7,8.087a.576.576,0,0,1-.712.735l-2.916-.874a.82.82,0,0,0-.9.3l-1.81,2.44a.577.577,0,0,1-.463.233",
    transform: "translate(-1690.039 -2195.863)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1323",
    "data-name": "Caminho 1323",
    d: "M29.641,58.961H3.393A3.392,3.392,0,0,1,0,55.579V3.382A3.392,3.392,0,0,1,3.393,0H43.238A3.392,3.392,0,0,1,46.63,3.382V37.06a.576.576,0,0,1-1.153,0V3.382a2.237,2.237,0,0,0-2.24-2.23H3.393a2.237,2.237,0,0,0-2.24,2.23v52.2a2.237,2.237,0,0,0,2.24,2.23H29.641a.576.576,0,1,1,0,1.153",
    transform: "translate(0 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1324",
    "data-name": "Caminho 1324",
    d: "M245.162,267H224.516a.576.576,0,0,1-.576-.576,4.469,4.469,0,0,0-4.473-4.455.576.576,0,0,1-.576-.576V223.707a.576.576,0,0,1,.576-.576,4.469,4.469,0,0,0,4.473-4.455.576.576,0,0,1,.576-.576H249.8a.576.576,0,0,1,.576.576,4.469,4.469,0,0,0,4.473,4.455.576.576,0,0,1,.576.576v23.384a.576.576,0,1,1-1.153,0V224.255a5.62,5.62,0,0,1-5.021-5H225.063a5.62,5.62,0,0,1-5.021,5v36.59a5.62,5.62,0,0,1,5.021,5h20.1a.576.576,0,0,1,0,1.153",
    transform: "translate(-213.843 -213.07)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1325",
    "data-name": "Caminho 1325",
    d: "M618.717,547.552H599.235a.576.576,0,0,1,0-1.153h19.481a.576.576,0,0,1,0,1.153",
    transform: "translate(-584.854 -533.799)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1326",
    "data-name": "Caminho 1326",
    d: "M520.4,798.052H496.163a.576.576,0,1,1,0-1.153H520.4a.576.576,0,1,1,0,1.153",
    transform: "translate(-484.159 -778.523)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1327",
    "data-name": "Caminho 1327",
    d: "M520.4,1048.552H496.163a.576.576,0,1,1,0-1.153H520.4a.576.576,0,1,1,0,1.153",
    transform: "translate(-484.159 -1023.247)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1328",
    "data-name": "Caminho 1328",
    d: "M520.4,1299.052H496.163a.576.576,0,1,1,0-1.153H520.4a.576.576,0,1,1,0,1.153",
    transform: "translate(-484.159 -1267.971)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1329",
    "data-name": "Caminho 1329",
    d: "M509.583,1549.552h-13.42a.576.576,0,1,1,0-1.153h13.42a.576.576,0,1,1,0,1.153",
    transform: "translate(-484.158 -1512.694)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1330",
    "data-name": "Caminho 1330",
    d: "M509.583,1800.052h-13.42a.576.576,0,1,1,0-1.153h13.42a.576.576,0,1,1,0,1.153",
    transform: "translate(-484.158 -1757.418)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNossosCertificados);
export default __webpack_public_path__ + "static/media/nossos-certificados.2f649a75a3ec6727772b0331f1562994.svg";
export { ForwardRef as ReactComponent };